import BansheeSimpleList from './src/SimpleList'

BansheeSimpleList.install = function (Vue) {
  Vue.component(BansheeSimpleList.name, BansheeSimpleList)
}

export default BansheeSimpleList
